import { categories, featuredComics } from '@/mocks/comics';

export default function CategoryHeader() {
  return (
    <section className="py-14 md:py-20 bg-accent-100/50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="mb-2">
          <span className="inline-block px-4 py-1.5 rounded-full bg-background-50 text-foreground-700 text-sm font-medium whitespace-nowrap">
            全部分类
          </span>
        </div>
        <h1 className="text-3xl md:text-5xl font-bold font-heading text-foreground-900 leading-tight mb-10 whitespace-nowrap">
          探索你喜欢的<br />漫画类型
        </h1>

        <div className="flex flex-wrap gap-8 md:gap-16 mb-14">
          {categories.slice(0, 4).map((cat) => (
            <div key={cat.id}>
              <h3 className="text-sm font-semibold text-foreground-800 whitespace-nowrap">{cat.name}</h3>
              <p className="text-xs text-foreground-500 mt-1">{cat.description}</p>
            </div>
          ))}
        </div>

        <div className="flex flex-wrap gap-8 md:gap-16">
          {[
            { label: '总漫画数', value: '2,500+', suffix: '部' },
            { label: '连载中', value: '1,820', suffix: '部' },
            { label: '已完结', value: '680', suffix: '部' },
            { label: '日更新', value: '45', suffix: '部' },
          ].map((stat, i) => (
            <div key={i}>
              <p className="text-3xl md:text-4xl font-bold font-heading text-foreground-900 whitespace-nowrap">
                {stat.value}
                <span className="text-lg md:text-xl font-normal text-foreground-500 ml-1">{stat.suffix}</span>
              </p>
              <p className="text-xs text-foreground-500 mt-1 whitespace-nowrap">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
